<i [class]="icon" ngSkipHydration></i>